import { type ReactElement } from "react";
import {
  Header,
  Footer,
  Hero,
  AboutMe,
  Projects,
  Skills,
  Building,
} from "@/containers";
import { Navbar } from "@/components";
import { useLanguage } from "@/context";
import { t } from "@/data";

const IS_RENEWING = false;

export const HomePage = (): ReactElement => {
  const { lang } = useLanguage();

  return (
    <div className="dark-mode">
      <a href="#main-content" className="skip-link">
        {t(lang, "skipToContent")}
      </a>
      <Header />
      {IS_RENEWING ? (
        <main>
          <Building />
        </main>
      ) : (
        <>
          <Navbar />
          <main id="main-content">
            <Hero />
            <Projects />
            <AboutMe />
            <Skills />
          </main>
          <Footer />
        </>
      )}
    </div>
  );
};
